import { Select } from "antd";
import { useState } from "react";

const { Option } = Select;

const MultiFilterSelect = ({ filterOptions, searchKeyword, setSearchKeyword }) => {
    const [selectedValues, setSelectedValues] = useState(searchKeyword.status || []);

    const handleFilterChange = (values) => {
        setSelectedValues(values);
        setSearchKeyword((prev) => ({ ...prev, status: values }));
    };

    const calculateWidth = () => {
        return Math.min(650, Math.max(220, searchKeyword.status?.length * 100 + 170)); // Max 500px
    };

    return (
        <Select
            mode="multiple"
            placeholder="Filter by Status"
            style={{ width: calculateWidth(), transition: "width 0.3s ease-in-out" }}
            onChange={handleFilterChange}
            value={selectedValues}
        >
            {filterOptions.map((option) => (
                <Option key={option} value={option}>
                    {option}
                </Option>
            ))}
        </Select>
    );
};

export default MultiFilterSelect;
